<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
const showButton = ref(false)
const handleScroll = () => {
    showButton.value = window.scrollY > 0;
};
const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
onMounted(() => {
    window.addEventListener('scroll', handleScroll);
});
onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});
</script>
<template>
    <div class="relative flex justify-end" v-show="showButton">
        <button  @click="scrollToTop" class="bg-primary sm:px-4 px-3 sm:py-2 py-1 bottom-8 sm:right-8 right-6 rounded-md text-center text-white border border-primary cursor-pointer hover:bg-[#1565C0] hover:border-[#1565C0] transition duration-300 fixed">
            <i class="fa fa-arrow-up sm:text-base text-sm"></i>
        </button>
    </div>
</template>
<style scoped></style>
